/*
 * Authors: Triadi, mariushirjanu
 * Created: 31/01/2020
 * Created: 14/09/2022
 */
import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges } from '@angular/core';
import { IDialogButton } from '../../../shared/message/ga-message.service';
import { ICustomerPermissionExtended, IOrderQuotePermissionResponse, IWebshopPermissionResponse, UserDataService } from '../../../shared/user/user-data.service';
import { PermissionsService } from './permissions.service';

@Component({
  selector: 'customer-permissions-dialog',
  template: `
    <default-dialog [title]="title" [buttons]="buttons">
      <customer-permissions [customerPermissions]="customerPermissions" [busyButton]="loadingCustomerPermissions"></customer-permissions>
    </default-dialog>
  `
})
export class CustomerPermissionsDialogComponent implements OnInit {
  @Input() public userId:number;
  @Output() public onCancel:EventEmitter<void> = new EventEmitter();

  public title:string = 'View Permissions';
  public buttons:IDialogButton[];
  public customerPermissions:ICustomerPermissionExtended;
  public loadingCustomerPermissions:boolean = true;

  constructor(
    private permissionsService:PermissionsService,
    private userDataService:UserDataService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.buttons = [ {
      label: 'GA.BUTTONS.CANCEL',
      onClick: () => this.onCancel.emit()
    } ];
  }

  public ngOnChanges(changesObj:SimpleChanges):void {
    if (changesObj?.userId) {
      this.userId = changesObj.userId.currentValue;
      this.start();
    }
  }

  private start():void {
    this.userDataService.getPermissions(this.userId)
      .then((permissions:IWebshopPermissionResponse | IOrderQuotePermissionResponse) => {
        this.customerPermissions = this.permissionsService.getCustomerPermissions(permissions);
      })
      .finally(() => {
        this.loadingCustomerPermissions = false;
      });
  }
}